import apiRequest from "services/apiRequest";
import {
    getSignedUrl,
    downloadFileAndShowInTab,
    prepareAndDownloadZipOfS3Files,
    downloadFileBlob, downloadZip
} from "./FilesAndS3Utils";
import ActionButtonComponent from "ui-components/ActionButtonComponent";
import ArrowDownTrayIcon from "@heroicons/react/24/solid/ArrowDownTrayIcon";
import {downloadBlob} from "../../../feature/commons/lib/utils";

export const buildQuotationsAttachments = (
    quotationsAttachments,
    intl,
    apiRequest,
    downloadQuotationPdf,
) => {

    const prepareAndDownloadZip = async (attachments) => {
		// await prepareAndDownloadZipOfS3Files(attachments, intl.formatMessage({id: 'quotations_attachments'}), apiRequest)
        const files = await Promise.all(attachments.map(async (doc) => {
            if (!!doc.s3_url) {
                const signed_url = await getSignedUrl(apiRequest, doc.s3_url, doc.name, doc.bucket);
                const blob = await downloadFileBlob(signed_url);
                return {filename: doc.name, blob: blob};
            } else {
                return {
                    filename: intl.formatMessage({
                        id: "quotation_pdf_filename",
                        defaultMessage: `Preventivo ${doc.quotation_id}.pdf`
                    }),
                    blob: downloadQuotationPdf(doc.quotation_id)
                }
            }
        }));
        return await downloadZip(intl.formatMessage({id: "quotations", defaultMessage: "Preventivi"}), files)
	}

    const buildDocumentInfo = async (attachment) => {
        let dateWithoutOffset
        const isoStr = attachment['created_at'];
        const date = new Date(isoStr);
        const offset = date.getTimezoneOffset() * 60 * 1000;
        const timestampWithOffset = date.getTime();
        const timestampWithoutOffset = timestampWithOffset - offset;
        dateWithoutOffset = new Date(timestampWithoutOffset);
        return `${intl.formatMessage({id: "created_on"})}
        ${intl.formatDate(dateWithoutOffset, {day: "numeric", month: "long", year: "numeric"})}
        ${intl.formatMessage({id: "at"})} ${intl.formatTime(dateWithoutOffset)}
        ${intl.formatMessage({id: "by"})} ${attachment.des_creator}`
    }

    const buildQuotationInfo = async (quotation) => {
        let dateWithoutOffset
        const isoStr = quotation['created_at'];
        const date = new Date(isoStr);
        const offset = date.getTimezoneOffset() * 60 * 1000;
        const timestampWithOffset = date.getTime();
        const timestampWithoutOffset = timestampWithOffset - offset;
        dateWithoutOffset = new Date(timestampWithoutOffset);
        return `${intl.formatMessage({id: "created_on"})}
        ${intl.formatDate(dateWithoutOffset, {day: "numeric", month: "long", year: "numeric"})}
        ${intl.formatMessage({id: "at"})} ${intl.formatTime(dateWithoutOffset)}
        ${intl.formatMessage({id: "by"})} ${quotation.des_creator}`
    }

    return {
        title: intl.formatMessage({id: "quotations", defaultMessage: "Preventivi"}),
        alternateColor: "bg-ivory",
        groups: quotationsAttachments?.map(quotationAttachments => {
            return {
                title: quotationAttachments.quotation.extended_id,
                documents:
                    [
                        {
                            name: quotationAttachments.quotation.extended_id,
                            onDocumentClicked: async () => {
                                const result = await downloadQuotationPdf(quotationAttachments.quotation.id)
                                downloadBlob(
                                    result,
                                    intl.formatMessage({
                                        id: "quotation_pdf_filename",
                                        defaultMessage:`Preventivo ${quotationAttachments.quotation.id}.pdf`
                                    })
                                );
                            },
                            selected: false,
                            visible: true,
                            info: buildQuotationInfo(quotationAttachments.quotation),
                            quotation_id: quotationAttachments.quotation.id
                        },
                        ...quotationAttachments.attachments.map((attachment) => {
                            return {
                                ...attachment,
                                bucket: 'quotations_attachments',
                                onDocumentClicked: async () => {
                                    const signed_url = await getSignedUrl(
                                        apiRequest,
                                        attachment.s3_url,
                                        attachment.name,
                                        'quotations_attachments'
                                    );
                                    await downloadFileAndShowInTab(signed_url, attachment.name);
                                },
                                selected: false,
                                visible: true,
                                info: buildDocumentInfo(attachment)
                            }
                        })
                    ],
            }
        }),
        actions: {
			download: {
				actionComponent: (documents, visible) => <ActionButtonComponent
					icon={ArrowDownTrayIcon}
					action={async () => {
						await prepareAndDownloadZip(documents)
					}}
				/>
			}
		}
    }
}